import React, { useEffect, useState } from 'react';
import { api } from '../../api/client';
import { useToast } from '../../components/Toast';
import { AsyncButton } from '../../components/AsyncButton';

function fmtDT(s: string) {
  return new Intl.DateTimeFormat('it-IT', { dateStyle:'short', timeStyle:'short' }).format(new Date(s));
}

export function AdminAuditPage() {
  const { push } = useToast();
  const [items, setItems] = useState<any[]>([]);

  async function load() {
    try {
      const r = await api.get<{items:any[]}>('/api/admin/audit-logs');
      setItems(r.items);
    } catch (e:any) {
      push({ title: 'Errore', body: e?.message });
    }
  }

  useEffect(() => { load(); }, []);

  return (
    <div className="grid" style={{ gap: 16 }}>
      <div className="card">
        <div className="spread">
          <div>
            <div className="h2" style={{ marginTop:0 }}>Audit log</div>
            <div className="small">Modifiche manuali alle timbrature (max 500).</div>
          </div>
          <AsyncButton className="btn btnSecondary" onClickAsync={load} busyText="Aggiorno…">Aggiorna</AsyncButton>
        </div>
      </div>

      <div className="card" style={{ padding: 0, overflow:'hidden' }}>
        <div style={{ overflowX:'auto' }}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead>
              <tr style={{ background:'var(--black)', color:'var(--white)' }}>
                <th style={{ padding: 12, textAlign:'left' }}>Quando</th>
                <th style={{ padding: 12, textAlign:'left' }}>Tipo</th>
                <th style={{ padding: 12, textAlign:'left' }}>Azione</th>
                <th style={{ padding: 12, textAlign:'left' }}>Entity</th>
              </tr>
            </thead>
            <tbody>
              {items.map((a, idx) => (
                <tr key={a._id} style={{ background: idx % 2 ? 'rgba(255,255,255,.02)' : 'rgba(255,255,255,.04)' }}>
                  <td style={{ padding: 12 }}>{fmtDT(a.created_at)}</td>
                  <td style={{ padding: 12 }}>{a.entity_type}</td>
                  <td style={{ padding: 12 }}>{a.action}</td>
                  <td style={{ padding: 12, maxWidth: 420, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{a.entity_id}</td>
                </tr>
              ))}
              {items.length === 0 ? <tr><td colSpan={4} className="small" style={{ padding: 16 }}>Nessun audit.</td></tr> : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
